import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6f6d5da4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Upload File to Google Drive", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "file-input-container" }
const _hoisted_5 = {
  for: "file-input",
  class: "file-label"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "error-message"
}
const _hoisted_8 = {
  key: 1,
  class: "success-message"
}
const _hoisted_9 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loginWithGoogle && _ctx.loginWithGoogle(...args))),
      class: "google-login-button"
    }, " Log in with Google "),
    (_ctx.isLoginSuccess)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Login successfull"))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("input", {
          type: "file",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
          id: "file-input"
        }, null, 32),
        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.selectedFile ? _ctx.selectedFile.name : 'Choose a file'), 1)
      ]),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadToGoogleDrive && _ctx.uploadToGoogleDrive(...args))),
        disabled: !_ctx.selectedFile || _ctx.isUploading,
        class: "upload-button"
      }, _toDisplayString(_ctx.isUploading ? 'Uploading...' : 'Upload to Google Drive'), 9, _hoisted_6),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true),
      (_ctx.uploadedFileLink)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createTextVNode(" File uploaded successfully! "),
            _createElementVNode("a", {
              href: _ctx.uploadedFileLink,
              target: "_blank"
            }, "View in Google Drive", 8, _hoisted_9)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}